import { Button } from "./Button";
import {
  basemapPlaceCategory,
  type BasemapPlace,
} from "../utils/basemapPlaces";
import { basemapPlaceMapsUrl } from "../utils/poiMaps";

interface BasemapPlacePopupProps {
  place: BasemapPlace;
  onAddToLibrary: (place: BasemapPlace) => void;
}

/**
 * Contents of the map popup for a basemap point of interest — a Mapbox tile
 * label rather than a library POI. Rendered into the Mapbox popup node via a
 * portal so it keeps the app's React context and shared components.
 */
export function BasemapPlacePopup({
  place,
  onAddToLibrary,
}: BasemapPlacePopupProps) {
  const category = basemapPlaceCategory(place);

  return (
    <div className="min-w-40 max-w-56 font-sans">
      <div className="text-sm font-semibold leading-snug text-primary">
        {place.name}
      </div>
      {category && (
        <div className="mt-0.5 text-2xs text-tertiary">{category}</div>
      )}
      <div className="mt-2 flex flex-col gap-1.5">
        <Button
          variant="primary"
          size="sm"
          icon="add_location_alt"
          fullWidth
          onClick={() => onAddToLibrary(place)}
        >
          Add to library
        </Button>
        <a
          href={basemapPlaceMapsUrl(place)}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-1.5 rounded-lg border border-border bg-white px-3 py-1.5 text-xs font-semibold text-primary no-underline transition-colors hover:bg-subtle"
        >
          <span className="material-symbols-outlined text-base">map</span>
          Open in Google Maps
        </a>
      </div>
    </div>
  );
}
